import { useMemo } from 'react';

import { BaseActionRenderProps } from 'src/legacy/components/AgGrid/Renderer/types';
import { Action, BaseActionsMenuButton } from 'src/legacy/components/Dropdowns';
import { TrashIcon } from 'src/legacy/components/Icons';

export interface ProductPriceTableRowModal {
  id: string;
  amount: number;
  currency: string;
  type: string;
  intervalCount: number;
  interval: string;
  status: string;
  createdAt: string;
  isUsed: boolean;
}

type EntityName = 'price' | 'product';

export interface ProductPriceActionsRendererProps
  extends BaseActionRenderProps {
  data: ProductPriceTableRowModal;
  handleClickRemove: (data: ProductPriceTableRowModal) => void;
  entityName: EntityName;
  isDeleteDisabled?: boolean;
  isPriceUsed?: boolean;
  mode?: string;
  onCurrentPriceAction?: Action;
}

export const PriceActionRenderer = ({
  data,
  handleClickRemove,
  onActionMenuClick,
  entityName,
  isDeleteDisabled,
  isPriceUsed,
  mode,
  onCurrentPriceAction,
}: ProductPriceActionsRendererProps) => {
  const toolTipLabel = useMemo(() => {
    if (isPriceUsed) {
      if (mode === 'Recurring') {
        return `Cannot delete this price because it is currently in use by the Subscription you are editing.`;
      }
      if (mode === 'All') {
        return `Cannot delete this price because it is currently in use by the payment link you are editing.`;
      }
      if (mode === 'OneTimeStore' || mode === 'subscriptionsStore') {
        return `Cannot delete this price because it is currently in use in your store.`;
      }
    }
    return `You can’t delete this ${entityName} because it has been used before (e.g. in invoice, subscription, store or payment link)`;
  }, [mode, entityName, isPriceUsed]);

  const actions: Action[] = [
    ...(onCurrentPriceAction ? [onCurrentPriceAction] : []),
    {
      name: `Delete`,
      onClick: () => handleClickRemove(data),
      icon: <TrashIcon />,
      isDelete: true,
      isDisabled: isDeleteDisabled || data.isUsed || isPriceUsed,
      tooltipLabel: toolTipLabel,
      ...(isDeleteDisabled && {
        tooltipLabel: `Each product must have at least one ${entityName}`,
      }),
    },
  ];

  return (
    <BaseActionsMenuButton
      onActionMenuClick={onActionMenuClick}
      actions={actions}
    />
  );
};
